import React from 'react';

interface IListGridProps {
    children?: React.ReactNode;
    isSingle?: boolean;
    isRelative?: boolean
}

export const ListGrid: React.FC<IListGridProps> = ({ children, isSingle = false, isRelative = false }) => {
    return <div className={`list-grid ${isSingle ? 'list-grid__single' : 'list-grid__multi'} ${isRelative && 'list-grid__relative'}`}>{children}</div>;
};
